import AmortizationTypes from "constants/amortizationTypes";

export const INTEREST_ONLY = "INTEREST_ONLY";
export const INTEREST_ONLY_ID = AmortizationTypes.INTEREST_ONLY;
export const STRAIGHT_LINE = "STRAIGHT_LINE";
export const STRAIGHT_LINE_CUSTOM_AMOUNT = "STRAIGHT_LINE_CUSTOM_AMOUNT";
export const MORTGAGE_STYLE = "MORTGAGE_STYLE";
export const MORTGAGE_STYLE_ID = AmortizationTypes.MORTGAGE_STYLE;
export const AGENCY_FLOATER = "AGENCY_FLOATER";
export const AGENCY_FLOATER_ID = AmortizationTypes.AGENCY_FLOATER;
export default {
  INTEREST_ONLY,
  STRAIGHT_LINE,
  STRAIGHT_LINE_CUSTOM_AMOUNT,
  MORTGAGE_STYLE,
  AGENCY_FLOATER,
  INTEREST_ONLY_ID,
  MORTGAGE_STYLE_ID,
  AGENCY_FLOATER_ID
};

